import { render, staticRenderFns } from "./FiltersSidebar.vue?vue&type=template&id=dea1169e&scoped=true&"
import script from "./FiltersSidebar.vue?vue&type=script&lang=js&"
export * from "./FiltersSidebar.vue?vue&type=script&lang=js&"
import style0 from "./FiltersSidebar.vue?vue&type=style&index=0&id=dea1169e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea1169e",
  null
  
)

export default component.exports